import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { TableCell } from '@mui/material';
import { TableRow } from '@mui/material';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ThinCheckbox } from 'components/common/Styles';
import TextTableCell from 'components/common/table/TextTableCell';

const DictionaryItem = ({ data }) => {
  const [t] = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/dictionaries/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow hover key={data.id}>
      <TextTableCell content={data.name} />
      <TextTableCell content={data.friendlyName} />
      <TableCell align='center'>
        <ThinCheckbox disabled={true} checked={Boolean(data.isReadOnly)} />
      </TableCell>
      <TableCell align='right'>
        <IconButton type='edit' size='small' variant='text' color='primary' tooltip={t('Dictionaries.Edit')} onClick={handleEdit} />
      </TableCell>
    </TableRow>
  );
};

DictionaryItem.propTypes = {
  data: PropTypes.object.isRequired
};

export default DictionaryItem;
